import { ProductData, InitialProductData } from "@/types/product";
import productProfileLoadData from "@/app/products/sku/[sku]/modelView/dataMapping/loadProductProfile";
import shapeProfileLoadData from "@/app/products/sku/[sku]/modelView/dataMapping/loadShapeProfile";
import sectionsLoadData from "@/app/products/sku/[sku]/modelView/dataMapping/loadSections";
import downloadFile from "@/services/downloadFile";

import getPrices from "@/services/ProductService/getPrices";
import getProduct from "@/services/ProductService/getProduct";
import getProductProfile from "@/services/ProductService/getProductProfile";
import getProductBundleItems from "@/services/ProductService/getProductBundleItems";



const initialProductData = async (sku: string): Promise<InitialProductData | null> => {
    try {



        // Load product data
        const productData: ProductData | null = await getProduct(sku);
        if (!productData) {
            throw new Error(`Product with SKU ${sku} not found.`);
        }




        // Load profile data and product pricing in parallel since they are not dependent
        const [profileData, productPricingList] = await Promise.all([
            getProductProfile(productData.product_profile_id),
            getPrices(),
        ]);



        // Load bundle items if the product is a bundle
        const bundleItems = (productData.is_bundle && productData?.bundle !== null)
            ? await getProductBundleItems(productData?.bundle.id).then(bundle => bundle?.bundle_items || [])
            : null;



        // Load the dependent files if profileData is available
        const objectFile = profileData?.shape_profile?.['3d_model_url']
            ? await downloadFile(profileData.shape_profile['3d_model_url'])
            : null;

        const stlFile = profileData?.shape_profile?.['stl_url']
            ? await downloadFile(profileData.shape_profile['stl_url'])
            : null;



        // Return the initial product data
        return {
            product: productData,
            profile: profileData,
            pricingList: productPricingList,
            mappedProfile: {
                product_profile: profileData ? productProfileLoadData(profileData) : null,
                shape_profile: profileData?.shape_profile ? shapeProfileLoadData(profileData.shape_profile) : null,
                sections: profileData?.shape_profile?.sections
                    ? sectionsLoadData(profileData.shape_profile.sections)
                    : null,
                objectFile,
                objectFile_url: profileData?.shape_profile?.['3d_model_url'] || null,
                stlFile,
                stlFile_url: profileData?.shape_profile?.['stl_url'] || null,
                pricing: profileData?.pricing?.['id'] || null,
            },
            bundleItems: bundleItems,
        };



    } catch (error) {
        console.error("Error loading initial product data:", error);
        return null;
    }
};

export default initialProductData;
